module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-left.9d7e8524.svg";